/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M13 17L18 17M13 12L18 12M13 7H18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 6V18M8 6L6 8M8 6L10 8M8 18L6 16M8 18L10 16M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M13 17L18 17M13 12L18 12M13 7H18M8 6V18M8 6L6 8M8 6L10 8M8 18L6 16M8 18L10 16M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25H14.75C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27433 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25V14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75H9.25C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75V9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27433 3.98005 1.79497ZM8.53036 5.46967C8.23747 5.17677 7.76259 5.17677 7.4697 5.46967L5.4697 7.46967C5.17681 7.76256 5.17681 8.23743 5.4697 8.53033C5.76259 8.82322 6.23747 8.82322 6.53036 8.53033L7.25003 7.81066V16.1893L6.53036 15.4697C6.23747 15.1768 5.76259 15.1768 5.4697 15.4697C5.17681 15.7626 5.17681 16.2374 5.4697 16.5303L7.4697 18.5303C7.76259 18.8232 8.23747 18.8232 8.53036 18.5303L10.5304 16.5303C10.8233 16.2374 10.8233 15.7626 10.5304 15.4697C10.2375 15.1768 9.76259 15.1768 9.4697 15.4697L8.75003 16.1893V7.81066L9.4697 8.53033C9.76259 8.82322 10.2375 8.82322 10.5304 8.53033C10.8233 8.23743 10.8233 7.76256 10.5304 7.46967L8.53036 5.46967ZM13 6.25C12.5858 6.25 12.25 6.58578 12.25 7C12.25 7.41421 12.5858 7.75 13 7.75H18C18.4142 7.75 18.75 7.41421 18.75 7C18.75 6.58578 18.4142 6.25 18 6.25H13ZM13 11.25C12.5858 11.25 12.25 11.5858 12.25 12C12.25 12.4142 12.5858 12.75 13 12.75H18C18.4142 12.75 18.75 12.4142 18.75 12C18.75 11.5858 18.4142 11.25 18 11.25H13ZM13 16.25C12.5858 16.25 12.25 16.5858 12.25 17C12.25 17.4142 12.5858 17.75 13 17.75L18 17.75C18.4142 17.75 18.75 17.4142 18.75 17C18.75 16.5858 18.4142 16.25 18 16.25L13 16.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 9.5V9V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H15C16.8613 22 17.7919 22 18.5451 21.7553C20.0673 21.2607 21.2607 20.0673 21.7553 18.5451C22 17.7919 22 16.8613 22 15V15V14.5M13 17L18 17M13 12L18 12M13 7H18M8 6V18M8 6L6 8M8 6L10 8M8 18L6 16M8 18L10 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M13 17L18 17M13 12L18 12M13 7H18M8 6V18M8 6L6 8M8 6L10 8M8 18L6 16M8 18L10 16M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.46967 5.46967C7.76256 5.17678 8.23744 5.17678 8.53033 5.46967L10.5303 7.46967C10.8232 7.76256 10.8232 8.23744 10.5303 8.53033C10.2374 8.82322 9.76256 8.82322 9.46967 8.53033L8.75 7.81066V16.1893L9.46967 15.4697C9.76256 15.1768 10.2374 15.1768 10.5303 15.4697C10.8232 15.7626 10.8232 16.2374 10.5303 16.5303L8.53033 18.5303C8.23744 18.8232 7.76256 18.8232 7.46967 18.5303L5.46967 16.5303C5.17678 16.2374 5.17678 15.7626 5.46967 15.4697C5.76256 15.1768 6.23744 15.1768 6.53033 15.4697L7.25 16.1893V7.81066L6.53033 8.53033C6.23744 8.82322 5.76256 8.82322 5.46967 8.53033C5.17678 8.23744 5.17678 7.76256 5.46967 7.46967L7.46967 5.46967ZM12.25 7C12.25 6.58579 12.5858 6.25 13 6.25H18C18.4142 6.25 18.75 6.58579 18.75 7C18.75 7.41421 18.4142 7.75 18 7.75H13C12.5858 7.75 12.25 7.41421 12.25 7ZM12.25 12C12.25 11.5858 12.5858 11.25 13 11.25L18 11.25C18.4142 11.25 18.75 11.5858 18.75 12C18.75 12.4142 18.4142 12.75 18 12.75L13 12.75C12.5858 12.75 12.25 12.4142 12.25 12ZM12.25 17C12.25 16.5858 12.5858 16.25 13 16.25L18 16.25C18.4142 16.25 18.75 16.5858 18.75 17C18.75 17.4142 18.4142 17.75 18 17.75L13 17.75C12.5858 17.75 12.25 17.4142 12.25 17Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
